<app-admin-page-model routeName="Catégories FAQ" pageTitle="Gestion des Catégories">
  <a [href]="'https://' + url + '/wp-login.php'" target="_blank">Accéder à la FAQ</a>

  <app-dynamic-modal-form
    title="Modification de la catégorie"
    [object]="toEdit"
    [actions]="[{label: 'Enregistrer', class: 'btn-primary', icon: 'save'}]"
    [generator]="categoryFormGeneratorService"
    (onSubmit)="saveCategory($event)">
    <ng-template let-form>
      <h2>Aperçu</h2>
      <app-badge [label]="mergeToEdited(form)"></app-badge>
      <h2>Contraste</h2>
      <app-color-contrast [color1]="form.getRawValue().textcolor"
                          [color2]="form.getRawValue().backcolor"></app-color-contrast>
    </ng-template>
  </app-dynamic-modal-form>

  <div class="mt-4">
    <ls-dynamic-table
      currentSort="name"
      sortAsc="false"
      [data]="categories | async"
      [headers]="tableaHeaders"
      [actions]="tableActions">
      <ng-template let-item>
        <td class="d-none d-md-table-cell">
          <app-badge [label]="item"/>
        </td>
        <th scope="row" class="d-table-cell d-md-none">
          <app-badge [label]="item"/>
        </th>
        <td class="d-none d-md-table-cell">
          {{item.name}}
        </td>
        <td>
          <span class="d-inline d-md-none">Couleur de fond : </span>
          {{item.backcolor}}
        </td>
        <td>
          <span class="d-inline d-md-none">Couleur de texte : </span>
          {{item.textcolor}}
        </td>
        <td>
          <span class="d-inline d-md-none">Accessibilité : </span>
          <app-color-contrast [color1]="item.textcolor" [color2]="item.backcolor"/>
        </td>
      </ng-template>
    </ls-dynamic-table>
  </div>

</app-admin-page-model>


